/* istanbul ignore file */
import { MainState } from "../typings/main_context_reducer";

export const initialMainState = (): MainState => {
  const state = {} as MainState;

  return state;
};
